import React, { useState } from 'react';

const ProgressiveImage = ({
  src,
  alt = 'Property image',
  className = '',
  ...props
}) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={`relative overflow-hidden ${className}`}>
      {/* Shimmer placeholder */}
      {!loaded && (
        <div
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(90deg, rgba(0,212,255,0.04) 25%, rgba(0,212,255,0.1) 50%, rgba(0,212,255,0.04) 75%)',
            backgroundSize: '200% 100%',
            animation: 'shimmer 1.5s infinite',
          }}
        />
      )}
      {/* Actual image with blur-up transition */}
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className={`w-full h-full object-cover transition-all duration-500 ${
          loaded ? 'opacity-100 scale-100' : 'opacity-0 scale-105'
        }`}
        onLoad={() => setLoaded(true)}
        onError={(e) => {
          e.target.src = '/assets/images/no_image.png';
          setLoaded(true);
        }}
        {...props}
      />
    </div>
  );
};

export default ProgressiveImage;
